module.exports = __webpack_public_path__ + "static/media/marketoProcess1.b31d7f5a.png";